import type { IconData } from '@stacksjs/iconify-core'

export const otherUiInbox: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M13 1H3L0 7.5h6V9a2 2 0 1 0 4 0V7.5h6z\"/><path fill=\"currentColor\" d=\"M16 9h-4.5a3.5 3.5 0 1 1-7 0H0v6h16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiInbox
